import { Box } from "@mui/material";
import { BossSouls, EnnemySouls } from "./EnnemySoulData";
import Item from "../../core/items/Item";


export interface EnnemyDto {
    name: string,
    img: string
}

const EnnemyTrackerVertical = () => {

    return<Box display="flex" flexDirection={"row"}> 

        <MinorEnnemyTracker />
        <BossSoulTracker />

 </Box>


}
export default EnnemyTrackerVertical;


const BossSoulTracker = () => {

    return  <Box display="flex" width="100px" flexDirection={"column"} marginLeft={10}>

    <Box display="flex" flexWrap={"wrap"} width="100px" flexDirection="row" justifyContent={"center"} alignItems={"flex-start"}>
     {BossSouls.map((e) => {
         return <Box display="flex" margin="5px">
             <Item id={e.name} image={e.img} title={e.name} imageComponent={(props: React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>)=> <img {...props} src={e.img} alt={e.name} height={100} width={100}/>}  />
         </Box>
     })}

 </Box>
 </Box>
}

const MinorEnnemyTracker = () => {

    return <Box display="flex" height="1000px" flexDirection={"column"}>
<Box display="flex" flexWrap={"wrap"} maxHeight="950px" flexDirection="column" justifyContent={"flex-start"} alignItems={"flex-start"}>
{EnnemySouls.map((e) => {
    return <Box display="flex" margin="5px">
        <Item id={e.name} image={e.img} title={e.name} tooltip={e.name.toLocaleUpperCase()} imageComponent={(props: React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>)=> <img {...props} src={e.img} alt={e.name} height={40} width={40}/>}  />
    </Box>
})}

</Box>
</Box>
}

